// extracted by mini-css-extract-plugin
export var option = "_4s-1";
export var optionActive = "_4s-2";
export var pill = "_4s-0";